import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import className from "classnames";
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Section from "../../elements/Section";
import { getRehydratableName, getClassNameFactory } from "../../utilities";

var HorizontalOverflow = /*#__PURE__*/function (_Component) {
  _inherits(HorizontalOverflow, _Component);

  var _super = _createSuper(HorizontalOverflow);

  function HorizontalOverflow(props) {
    var _this;

    _classCallCheck(this, HorizontalOverflow);

    _this = _super.call(this, props);
    _this.getClassName = getClassNameFactory(HorizontalOverflow.displayName);
    _this.resizeDebounceTimeout = 200;
    _this.toggleOverflowIndicators = _this.toggleOverflowIndicators.bind(_assertThisInitialized(_this));
    _this.toggleOverflowIndicatorsDebounced = debounce(_this.toggleOverflowIndicators, _this.resizeDebounceTimeout).bind(_assertThisInitialized(_this));
    _this.state = {
      overflowEnd: false,
      overflowStart: false
    };
    return _this;
  }

  _createClass(HorizontalOverflow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.toggleOverflowIndicatorsDebounced);
      this.toggleOverflowIndicators();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.toggleOverflowIndicatorsDebounced);
    }
  }, {
    key: "toggleOverflowIndicators",
    value: function toggleOverflowIndicators() {
      if (this.innerEl.offsetWidth >= this.innerEl.scrollWidth) {
        this.setState({
          overflowEnd: false,
          overflowStart: false
        });
        return;
      }

      if (this.innerEl.scrollLeft === 0) {
        this.setState({
          overflowStart: false
        });
      } else {
        this.setState({
          overflowStart: true
        });
      }

      if (this.innerEl.scrollLeft >= this.innerEl.scrollWidth - this.innerEl.offsetWidth) {
        this.setState({
          overflowEnd: false
        });
      } else {
        this.setState({
          overflowEnd: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          background = _this$props.background,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          modifiers: className(background),
          states: className({
            overflowEnd: this.state.overflowEnd,
            overflowStart: this.state.overflowStart
          })
        }),
        "data-background": background,
        "data-rehydratable": getRehydratableName(HorizontalOverflow.displayName),
        ref: function ref(_ref2) {
          _this2.outerEl = _ref2;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "inner"
        }),
        onScroll: this.toggleOverflowIndicators,
        ref: function ref(_ref) {
          _this2.innerEl = _ref;
        },
        "data-rehydratable-children": true
      }, children));
    }
  }]);

  return HorizontalOverflow;
}(Component);

_defineProperty(HorizontalOverflow, "displayName", "HorizontalOverflow");

_defineProperty(HorizontalOverflow, "propTypes", {
  background: PropTypes.oneOf(Section.backgrounds),
  children: PropTypes.node.isRequired
});

export default HorizontalOverflow;